// <s-growth-story> — ROOTX scroll story. Maps the section's scroll progress to --p (0–1), the active week stage
// and the week counter, so the illustrated strands grow as the buyer scrolls. Reduced motion keeps the final state.
class SGrowthStory extends HTMLElement {
  #ac = null;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    this.setAttribute("data-live", "");
    const tick = () => {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    };
    window.addEventListener("scroll", tick, { passive: true, signal });
    window.addEventListener("resize", tick, { passive: true, signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #update() {
    const rect = this.getBoundingClientRect();
    const travel = Math.max(1, rect.height - window.innerHeight);
    const p = Math.min(1, Math.max(0, -rect.top / travel));
    this.style.setProperty("--p", p.toFixed(3));
    const stages = this.querySelectorAll("[data-gs-stage]");
    const active = Math.min(stages.length - 1, Math.floor(p * stages.length));
    stages.forEach((stage, i) => {
      stage.toggleAttribute("data-active", i === active);
      stage.toggleAttribute("data-past", i < active);
    });
    const week = this.querySelector("[data-gs-week]");
    if (week) week.textContent = String(Math.max(1, Math.round(1 + p * 11))).padStart(2, "0");
  }
}

if (!customElements.get("s-growth-story")) customElements.define("s-growth-story", SGrowthStory);
